import {
  AccessTimeOutlined,
  CheckOutlined,
  ClearOutlined,
  DateRangeOutlined,
  DoDisturb,
  ErrorOutlineOutlined,
  EventRepeatOutlined,
  ManageHistoryOutlined,
  PersonPinCircleOutlined,
  SupportAgentOutlined,
  TroubleshootOutlined,
  TurnSlightRightOutlined,
  AddCircleOutlined,
  SyncOutlined,
  CheckCircleOutlineOutlined,
  PendingOutlined,
} from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./styles";

export function StatusIconCard(statusId, type = 1) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const config = {
    1: {
      label: "Aguardando análise",
      icon: AccessTimeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    2: {
      label: "Resolvido",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    3: {
      label: "Pendente",
      icon: ErrorOutlineOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.outputData,
    },
    4: {
      label: "Cancelado",
      icon: DoDisturb,
      bgColor: theme.palette.colors.gray.darker,
    },
    5: {
      label: "Aberto",
      icon: ErrorOutlineOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.outputData,
    },
    6: {
      label: "Encaminhado",
      icon: TurnSlightRightOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.speeData,
    },
    7: {
      label: "Agendado",
      icon: DateRangeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    8: {
      label: "Em análise",
      icon: TroubleshootOutlined,
      bgColor: theme.palette.colors.orange.darker,
    },
    9: {
      label: "Assumido",
      icon: SupportAgentOutlined,
      bgColor: theme.palette.colors.blue.dark,
    },
    10: {
      label: "Em execução",
      icon: ManageHistoryOutlined,
      bgColor: theme.palette.colors.yellow.darker,
    },
    11: {
      label: "Finalizado",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    12: {
      label: "Deslocamento",
      icon: PersonPinCircleOutlined,
      bgColor: theme.palette.colors.purple.dark,
    },
    13: {
      label: "Reagendar",
      icon: EventRepeatOutlined,
      bgColor: theme.palette.colors.pink.dark,
    },
    14: {
      label: "N/A",
      icon: ClearOutlined,
      bgColor: theme.palette.colors.gray.darker,
    },
    15: {
      label: "Solucionado",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    16: {
      label: "Novo",
      icon: AddCircleOutlined,
      bgColor: theme.palette.colors.blue.dark,
    },
    17: {
      label: "Em progresso",
      icon: SyncOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    18: {
      label: "Fechamento",
      icon: CheckCircleOutlineOutlined,
      bgColor: theme.palette.colors.blue.dark,
    },
    19: {
      label: "Encerramento",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    20: {
      label: "Abertura",
      icon: AddCircleOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    21: {
      label: "Andamento",
      icon: AccessTimeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.outputData,
    },
    22: {
      label: "Ag. Classificação",
      icon: PendingOutlined,
      bgColor: theme.palette.colors.yellow.darker,
    },
    23: {
      label: "Em atendimento",
      icon: AccessTimeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
  };

  const current = config[statusId];
  if (!current) return null;

  const Icon = current.icon;

  return (
    <Tooltip placement="top" title={current.label}>
      <Box
        sx={{
          ...(type === 1 ? styles.boxIcon : styles.boxIconStyleOs),
          backgroundColor: current.bgColor,
        }}
      >
        <Typography sx={styles.titleStatusCard}>{current.label}</Typography>
        <Icon
          sx={{
            ...styles.iconStatus,
            color: theme.palette.white.main,
          }}
        />
      </Box>
    </Tooltip>
  );
}
